import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { MessageMiddlewareContext } from "./message-middleware";

const noop = () => { };

export type MessageMiddlewareContextTemplate = Omit<MessageMiddlewareContext, "user">;

export class MiddlewareContextFactory {

    private readonly cache: {
        [key: string]: MessageMiddlewareContext
    } = {};

    private readonly template: MessageMiddlewareContextTemplate

    constructor(
        template: MessageMiddlewareContextTemplate
    ) {
        this.template = template;
    }

    public resolve(user: ChatUserInfo): MessageMiddlewareContext | undefined {
        if (!user) {
            return undefined;
        }

        const cache = this.cache;

        const key = user.nick;
        let val = cache[key];
        if (!val) {
            val = {
                user,
                send: this.template.send ?? noop,
                write: this.template.write ?? noop,
                openUrl: this.template.openUrl ?? noop
            };
            cache[key] = val;
        }
        return val;
    }

}
